// The filtering behind MediaBrowser, free of React like carFilters.ts.
import { normalize } from '@/shared/cars/carFilters'
import { EventsShowMedia } from '@/types/events_show'

export interface MediaFilters {
  /** MediaGroup::LISTINGS keys; a group matches any of them. */
  listings: string[]
  query: string
}

export const NO_FILTERS: MediaFilters = { listings: [], query: '' }

export function filtersActive(filters: MediaFilters): boolean {
  return filters.listings.length > 0 || filters.query.trim() !== ''
}

/**
 * The listings present at this event, most common first. Read off the data
 * rather than a fixed list, so a new kind of media shows up as a chip without
 * the page knowing about it.
 */
export function listingFacets(media: EventsShowMedia[]): { value: string; label: string; count: number }[] {
  const counts = new Map<string, { value: string; label: string; count: number }>()
  media.forEach((m) => {
    const entry = counts.get(m.listing) ?? { value: m.listing, label: m.listing_label, count: 0 }
    entry.count += 1
    counts.set(m.listing, entry)
  })
  return [...counts.values()].sort((a, b) => b.count - a.count || a.label.localeCompare(b.label))
}

/** Every word against the name, where they're from, and any handle or link they gave. */
function matchesQuery(media: EventsShowMedia, query: string): boolean {
  const words = normalize(query).split(/\s+/).filter(Boolean)
  if (words.length === 0) return true

  const haystack = [
    media.name,
    media.location,
    media.listing_label,
    media.instagram,
    media.youtube,
    media.flickr,
    media.facebook,
    media.tiktok,
    media.threads,
    media.website,
  ]
    .map(normalize)
    .join(' ')
  return words.every((word) => haystack.includes(word.replace(/^@/, '')))
}

export function mediaMatches(media: EventsShowMedia, filters: MediaFilters): boolean {
  if (filters.listings.length > 0 && !filters.listings.includes(media.listing)) return false
  return matchesQuery(media, filters.query)
}
